export default __webpack_public_path__ + "static/media/authentication4.2cefdbde.png";